export function getIsLoading(state){
    return state.ui.isLoading
}

export function getHasError(state){
    return state.ui.hasError
}

export function getError(state){
    return state.ui.error
}

export function getHasBSRSLoginFail(state){
    return state.ui.hasBSRSLoginFail === true
}



// WEBPACK FOOTER //
// ./src/features/ui/selectors.js